<ng-container *ngIf="organization">
  <div class="ui-kit-blocks-list--with-separator">
    <div class="ui-kit-rows-layout">
      <div class="ui-kit-block-title" translate>organization.certificate.individual.data</div>
      <div class="ui-kit-layout-columns-2" data-qa="iin">
        <span translate>organization.iin</span>
        <span data-qa-value>{{ organization?.INN }}</span>
      </div>
      <div class="ui-kit-layout-columns-2" data-qa="organization-type">
        <span translate>organization.oked</span>
        <span>{{ organization?.okved }}</span>
      </div>
      <div class="user__parameter">
        <span translate [class.required-marker]="registrationType === registrationTypes.SMS"
          >organization.form.type</span
        >
        <tax-dropdown-list
          [data]="organizationTypes"
          [currentItem]="organization?.organisationForm"
          (submittedData)="selectedOrganizationTypes($event)"
          id="organizationType"
        ></tax-dropdown-list>
      </div>
      <div class="ui-kit-layout-columns-2" data-qa="manager-fio">
        <span translate [class.required-marker]="registrationType === registrationTypes.SMS"
          >organization.manager.fio</span
        >
        <span
          data-qa-value
          *ngIf="
            organization?.taxpayer?.lastName &&
            organization?.taxpayer?.firstName &&
            organization?.taxpayer?.secondName
          "
          >{{
            organization?.taxpayer?.lastName +
              ' ' +
              organization?.taxpayer?.firstName +
              ' ' +
              organization?.taxpayer?.secondName
          }}</span
        >
        <tax-input
          *ngIf="
            !organization?.taxpayer?.lastName ||
            !organization?.taxpayer?.firstName ||
            !organization?.taxpayer?.secondName
          "
          id="fio"
          name="fio"
          [(ngModel)]="fio"
          taxIsHaveNameAndSurnameValidator
        ></tax-input>
      </div>
    </div>

    <div class="ui-kit-rows-layout">
      <div class="ui-kit-block-title" translate>organization.payment</div>
      <div class="ui-kit-layout-columns-2" data-qa="bank-name">
        <span translate>organization.bank</span>
        <span data-qa-value>{{ organization?.bank }}</span>
      </div>
      <div class="ui-kit-layout-columns-2">
        <label translate>organization.bic</label>
        <tax-dropdown-list
          [data]="banks"
          [currentItem]="organization?.bic"
          (submittedData)="selectedBank($event)"
          id="bic"
        ></tax-dropdown-list>
      </div>
      <div class="ui-kit-layout-columns-2">
        <label translate>organization.iik</label>
        <div>
          <input
            [class.invalid]="!isIikValid(organization?.paymentAccount)"
            class="text_field iik"
            placeholder="{{ 'organization.iik.placeholder' | translate }}"
            type="text"
            maxlength="20"
            [ngModel]="organization?.paymentAccount"
            (change)="iikChange($event)"
            id="paymentAccount"
          />
          <p
            *ngIf="!isIikValid(organization?.paymentAccount)"
            class="error-text column-2"
            translate
          >
            organisation.iik.invalid
          </p>
        </div>
      </div>
    </div>

    <div class="ui-kit-rows-layout">
      <div class="ui-kit-block-title" translate>organization.contacts</div>
      <div class="ui-kit-layout-columns-2" data-qa="legal-address">
        <span class="required-marker" translate>organization.legal.address</span>
        <span data-qa-value>{{
          organization?.legalAddress?.fullAddress ||
            ('organisation.legal.address.placeholder' | translate)
        }}</span>
        <button
          class="button_link column-2"
          [taxOpenAddressSelector]="isRegistration ? organization.legalAddress : null"
          (newAddress)="setLegalAddress($event)"
          translate
        >
          organization.legal.address.update
        </button>
      </div>

      <div class="ui-kit-layout-columns-2" data-qa="actual-address">
        <span class="required-marker" translate>organization.actual.address</span>
        <span [class.disabled]="isSameAddress" data-qa-value>{{
          organization?.actualAddress?.fullAddress ||
            ('organisation.individual.address.placeholder' | translate)
        }}</span>
        <button
          [disabled]="isSameAddress"
          [taxOpenAddressSelector]="isRegistration ? organization.actualAddress : null"
          (newAddress)="setActualAddress($event)"
          class="button_link column-2"
          translate
        >
          organization.legal.address.update
        </button>
        <label for="sameAddress" class="column-2" data-qa-checkbox="same-address">
          <input
            type="checkbox"
            data-qa="checkbox"
            id="sameAddress"
            name="sameAddress"
            [checked]="isSameAddress"
            (change)="toggleActualAddress()"
          />
          <span translate data-qa="checkbox-label-text">organization.same.address</span>
        </label>
      </div>
    </div>

    <div class="ui-kit-rows-layout">
      <div class="ui-kit-layout-columns-2" data-qa="email">
        <span class="required-marker" translate>organization.email</span>
        <div class="user-email">
          <span data-qa-value>{{ organization?.email || 'username@hostname.com' }}</span>
          <svg-icon key="done" *ngIf="isEmailVerified" class="green-icon"></svg-icon>
        </div>
        <button
          class="button_link column-2"
          taxOpenEmailConfirmModal
          (emailCorrect)="emailVerifier($event)"
          translate
        >
          organization.legal.address.update
        </button>
      </div>

      <ng-container *ngIf="isRegistration">
        <div class="ui-kit-layout-columns-2" *ngIf="registrationType === registrationTypes.SMS">
          <span translate>organization.phone</span>
          <span>{{ organization?.phone }}</span>
        </div>
        <tax-phone-input
          *ngIf="registrationType === registrationTypes.EDS"
          [required]="true"
          placeholder="organization.phone.placeholder"
          [(ngModel)]="organization.phone"
          [layoutColumns]="2"
          [width]="'148px'"
          [id]="'phone'"
        ></tax-phone-input>
      </ng-container>
      <div class="ui-kit-layout-columns-2" *ngIf="!isRegistration">
        <div translate class="required-marker">organization.phone</div>
        <div class="phone" [class.grey-text]="!organization?.phone">
          {{ organization?.phone || ('user.form.phone.not.exist' | translate) }}
        </div>
        <button class="button_link column-2" (click)="setPhone()" translate type="button">
          {{ organization?.phone ? 'button.change' : 'button.designate' }}
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isRegistration" class="checkbox" data-qa-checkbox="confirm">
    <input
      type="checkbox"
      data-qa="checkbox"
      id="contract"
      [(ngModel)]="organization.confirmOffer"
    />
    <label for="contract" data-qa="checkbox-label-text">
      <a href="/api/registration/load-contract-pdf" target="_blank">
        <span translate>registration.offer.confirm.first.part</span>
      </a>
      {{ 'registration.offer.confirm.second.part' | translate }}
    </label>
  </div>

  <div class="ui-kit-bottom-buttons-block">
    <button class="back-button" (click)="back()" translate>group.back</button>
    <button
      class="button_blue"
      [disabled]="!isFormValid()"
      (click)="onSubmit()"
      data-qa="send-button"
      translate
    >
      {{ isRegistration ? 'organization.continue' : 'organization.save' }}
    </button>
  </div>
</ng-container>
